// Display names for the Nexus trip events, aligned with the standard (AI)
// delivery event names. The device backend sends the raw codes.
const NEXUS_EVENT_LABELS = {
  ARRIVED_AT_ORIGIN: "Arrived at Pickup Point",
  DELIVERY_JOURNEY_STARTED: "Delivery Journey Started",
  REACHED_DELIVERY_POINT: "Reached Delivery Point",
  // Older trips recorded leaving a drop as LEAVE_DESTINATION. Leaving a drop now
  // starts the journey to the next consignee, so it reads the same way.
  LEAVE_DESTINATION: "Delivery Journey Started",
  RETURN_TO_STARTING: "Return Journey Started",
  RETURN_TO_BASE: "Returned To Base",
  FINISHED: "Finished",
};

// A Collection uses the same events under different names (as in TrackRight AI).
// It has no "Arrived at Pickup Point" first event: it starts by leaving the start.
const NEXUS_COLLECTION_LABELS = {
  DELIVERY_JOURNEY_STARTED: "Pickup Journey Started",
  LEAVE_DESTINATION: "Pickup Journey Started",
  REACHED_DELIVERY_POINT: "Arrived Pickup Point",
  RETURN_TO_STARTING: "Delivery Journey Started",
  RETURN_TO_BASE: "Reached Delivery Point",
};

// Event filter options (value = raw event code), in journey order
export const NEXUS_EVENT_OPTIONS = Object.entries(NEXUS_EVENT_LABELS).map(([value, label]) => ({
  value,
  label,
}));

const EVENT_RANK = {
  ARRIVED_AT_ORIGIN: 1,
  DELIVERY_JOURNEY_STARTED: 2,
  REACHED_DELIVERY_POINT: 3,
  LEAVE_DESTINATION: 4,
  RETURN_TO_STARTING: 5,
  RETURN_TO_BASE: 6,
  FINISHED: 7,
};

const eventMillis = (ev) => {
  const t = new Date(ev?.eventtime ?? ev?.cron ?? 0).getTime();
  return Number.isNaN(t) ? 0 : t;
};

// Events in the order they happened: by event time (the time the record was
// received when the device sent none), then journey order for events that share a
// time. Takes lower-cased rows (eventname / eventtime / cron) holding the raw
// event codes, so call it before labelling. Returns a new array.
export const sortNexusEvents = (events) =>
  [...(events || [])].sort((a, b) => {
    const dt = eventMillis(a) - eventMillis(b);
    if (dt !== 0) return dt;
    const ra = EVENT_RANK[String(a?.eventname || "").trim().toUpperCase()] || 0;
    const rb = EVENT_RANK[String(b?.eventname || "").trim().toUpperCase()] || 0;
    if (ra !== rb) return ra - rb;
    return new Date(a?.cron ?? 0).getTime() - new Date(b?.cron ?? 0).getTime();
  });

// shipmentType: 1 = Delivery (default), 2 = Collection
export const nexusEventLabel = (name, shipmentType) => {
  if (name == null || name === "") return name;
  const key = String(name).trim().toUpperCase();
  if (Number(shipmentType) === 2 && NEXUS_COLLECTION_LABELS[key]) {
    return NEXUS_COLLECTION_LABELS[key];
  }
  return (
    NEXUS_EVENT_LABELS[key] ||
    String(name)
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
};
